import React, { useState, useEffect } from 'react';
import {List, ListItem, Button, Grid, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Paper, Box} from '@mui/material/';
import mentor_pic from './../mentor_pic.jpeg';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import {times} from '../json/times';
import {useNavigate, useLocation, Link} from 'react-router-dom';
import axios from "axios"
import * as constants from './../constants'
import MenuAppBar from "../components/MenuAppBar";
import {Typography} from "@mui/material";
import timezones from "../json/timezones.json";

export const DialogBox = ({open, handleClose, confirmSession, mentor, date, time, duration}) => {
    return (
        <Dialog
          fullWidth
          open={open}
          onClose={handleClose}
        >
          <DialogTitle className='center-align'>
            {"Confirm Session"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <span className='col-center'>
                <span>Confirm session with {mentor}?</span>
                <br/>
                <span>Date: {date}</span>
                <span> Time: {time}</span>
                <span>Duration: {duration}</span>
              </span>
            </DialogContentText>
          </DialogContent>
          <DialogActions className='center-align'>
            <Button variant='outlined' onClick={handleClose}>Cancel</Button>
            <Button variant='outlined' onClick={confirmSession} autoFocus>
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
    );
}


export default function BookSession() {

    const [error, setError] = useState('')

    const [date, setDate] = useState(dayjs(new Date()));

    const [id, setId] = useState(1)

    const [avlTimes, setAvlTimes] = useState(times) //need to fetch mentors available times from api

    const [open, setOpen] = useState(false);

    const [selectedTime, setSelectedTime] = useState();

    const [duration, setDuration] = useState('30 mins');

    const [name, setName] = useState('')

    const [ready, setReady] = useState(false)

    const [timezone, setTimezone] = useState("")

    const location = useLocation();


    function addDays (date, days) {
        date.setDate(date.getDate() + days);
        return date;
    }
    function getMinDate() {
        return addDays(new Date(), 2);
    }
    function getMaxDate() {
        return addDays(new Date(), 14);
    }

    //This runs once when the page is loading
    useEffect(() => {
        let id = parseInt(window.location.href.split('?mentorId=')[1])
        setId(id)
        if (location.state) {
            const data = { mentor: location.state.mentor, date: dayjs(date).format('MM/DD/YYYY') };
            axios
                .post(constants.serverURL + "getAvailableSessions", {id: id},{withCredentials: true})
                .then(response => {
                    //set mentor's name
                    setName(response.data.firstName + " "+ response.data.lastName)

                    let zone = Intl.DateTimeFormat().resolvedOptions().timeZone
                    let timezoneName = "(UTC-05:00) Eastern Time (US & Canada)"
                    for (let i = 0; i < timezones.length; i++) {
                        let zoneNames = timezones[i].utc
                        for (let j = 0; j < zoneNames.length; j++) {
                            if (zone === zoneNames[j]) {
                                timezoneName = timezones[i].text
                            }
                        }
                    }
                    setTimezone(timezoneName)

                    //get list of mentor's available schedules
                    let schedules = response.data.schedules
                    console.log(schedules)

                    //object with 7 arrays with available times
                    let availability = {
                        Monday: {times:[]},
                        Tuesday: {times:[]},
                        Wednesday: {times:[]},
                        Thursday: {times:[]},
                        Friday: {times:[]},
                        Saturday: {times:[]},
                        Sunday: {times:[]}
                    }

                    //populate availability object
                    for (let i = 0; i < schedules.length; i++) {
                        let startTime  = new Date(schedules[i].start)
                        let endTime = new Date(schedules[i].end)
                        let startHour = startTime.getHours()
                        let startMinute = startTime.getMinutes()
                        let endHour = endTime.getHours()
                        let endMinute = endTime.getMinutes()
                        let startTimeString = ""
                        let endTimeString = ""
                        let startPm = false
                        let endPm = false

                        //Check if time is am or pm
                        if (startHour >= 12) {
                            startHour -= 12
                            startPm = true
                        }
                        if (endHour >= 12) {
                            endHour -= 12
                            endPm = true
                        }

                        //If hour is less than 10, add 0 before (9:30 -> 09:30)
                        if (startHour < 10) startTimeString += "0"
                        if (endHour < 10) endTimeString += "0"

                        startTimeString += startHour + ":"
                        endTimeString += endHour + ":"

                        //If minute is less than 10, add 0 before (10:0 -> 10:00)
                        if (startMinute < 10) startTimeString += "0"
                        if (endMinute < 10) endTimeString += "0"

                        startTimeString += startMinute
                        endTimeString += endMinute

                        if (startPm) {
                            startTimeString += "PM"
                        } else {
                            startTimeString += "AM"
                        }
                        if (endPm) {
                            endTimeString += "PM"
                        } else {
                            endTimeString += "AM"
                        }

                        let timeString = startTimeString + "-" + endTimeString

                        switch(startTime.getDay()) {
                            case 0:
                                availability.Sunday.times.push(timeString)
                                break;
                            case 1:
                                availability.Monday.times.push(timeString)
                                break;
                            case 2:
                                availability.Tuesday.times.push(timeString)
                                break;
                            case 3:
                                availability.Wednesday.times.push(timeString)
                                break;
                            case 4:
                                availability.Thursday.times.push(timeString)
                                break;
                            case 5:
                                availability.Friday.times.push(timeString)
                                break;
                            case 6:
                                availability.Saturday.times.push(timeString)
                                break;
                        }
                    }
                    setAvlTimes(availability)
                    //render the page
                    setReady(true)
                })
                .catch(error => {
                });
        }
    }, []);

    const handleClose = () => {
        setOpen(false);
    };

  
    const handleClickOpen = (time) => {
        setOpen(true);
        setSelectedTime(time)
    };

    const confirmSession = (event) => {
        setError("")
        handleClose()
        axios.post(constants.serverURL + "joinSession", {id: id, time: selectedTime, date: dayjs(date).format('MM/DD/YYYY'), timezone: timezone},{withCredentials: true})
            .then(response => {
                window.location.href = constants.websiteURL + '#/main?message=success'
            })
            .catch(error => {
                if (error.request.responseText === 'expired token') {
                    window.location.href = constants.websiteURL + '#/refreshToken?redirect=booksession?mentorId=' + id
                } else {
                    setError(error.request.responseText)

                }
            });
    }
    location.state = true;

    function disableDates(date) {
        switch(date.$W) {
            case 0:
                if (avlTimes.Sunday.times.length === 0) {
                    return 1
                }
                return 0
            case 1:
                if (avlTimes.Monday.times.length === 0) {
                    return 1
                }
                return 0
            case 2:
                if (avlTimes.Tuesday.times.length === 0) {
                    return 1
                }
                return 0
            case 3:
                if (avlTimes.Wednesday.times.length === 0) {
                    return 1
                }
                return 0
            case 4:
                if (avlTimes.Thursday.times.length === 0) {
                    return 1
                }
                return 0
            case 5:
                if (avlTimes.Friday.times.length === 0) {
                    return 1
                }
                return 0
            case 6:
                if (avlTimes.Saturday.times.length === 0) {
                    return 1
                }
                return 0
            default:
                return 1
        }
    }
  
    return (
        <div>
            <MenuAppBar title="Mentee Survey" signedIn={true}></MenuAppBar>
            {ready ?
            <div className="screen">
                {
                    error &&
                    <ListItem sx={{ p:2, my:1.5}} className='question-block'>
                        <Typography className="font-16 error-message">{error}</Typography>
                    </ListItem>
                }
                <Grid container className="col-center">
                    <Grid item xs={12} md={3}>
                        <div className='row-align' style={{padding:20}}>
                            <p className="center-align font-18">{name}</p>
                            <img
                            src={constants.mentorImageBucketURL + id + '.png'}
                            alt="Not Found"
                            className="circle"
                            />
                            <div className="center-align font-16">Mentor Session</div>
                            <div className="center-align font-16">Duration: 30 mins</div>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={9} className='question-block'>
                        <div className="center-align font-18" style={{padding: 20}}>Select Date and Time</div>
                        <Grid item container xs width={'100%'} alignItems="center" justifyContent="center">
                            <Grid item xs={12} md={6}>
                                <Paper style={{margin: 10}}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs} width={'100%'}>
                                        <DateCalendar shouldDisableDate={disableDates} className="cal-width" value={date} minDate={dayjs(getMinDate())} maxDate={dayjs(getMaxDate())}onChange={(newDate) => setDate(newDate)} disablePast/>
                                    </LocalizationProvider>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <div className="col-center">
                                    <div className="center-align font-16" style={{marginBottom: 10}}>Available Times on {dayjs(date).format('dddd')}</div>
                                    <Box style={{maxHeight: 270, overflow: 'auto', margin: 10}} className='center-align'>
                                        <List className='col-center'>
                                            {
                                                avlTimes[dayjs(date).format('dddd')].times.map((time) => {
                                                    console.log(date)
                                                    console.log(time)
                                                    let today = new Date()
                                                    if (date.$y === today.getFullYear() && date.$M === today.getMonth() && date.$D === today.getDate()) {
                                                        return(
                                                            <div key={"empty"}></div>
                                                        )
                                                    }
                                                return(
                                                <ListItem key={time} className="center-align">
                                                    <Button
                                                    variant='outlined'
                                                    key={time}
                                                    style={{width: 100}}
                                                    onClick={() => handleClickOpen(time)}>
                                                        {time}
                                                    </Button>
                                                </ListItem>)
                                            })}
                                        </List>
                                    </Box>
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <DialogBox
                    open={open}
                    handleClose={handleClose}
                    confirmSession={confirmSession}
                    mentor = {name}
                    date = {dayjs(date).format('dddd, MM/DD/YYYY')}
                    time = {selectedTime}
                    duration = {duration}
                />
                <Link className="font-16 primary-color" to="/topMentors">Choose another mentor &gt;&gt;</Link>
            </div>
            : <div></div>
            }
        </div>
    );
}

